
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"sitesDashboard"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentAccount"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sites"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metricStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentWeight"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"weightDeltas5d"},"name":{"kind":"Name","value":"deltaWeights"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"5d","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"timeBucket"},"value":{"kind":"StringValue","value":"1d","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"weightDelta1d"},"name":{"kind":"Name","value":"deltaWeight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"1d","block":false}}],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"weightDelta1w"},"name":{"kind":"Name","value":"deltaWeight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"1w","block":false}}],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"hives"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"metricStats"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"minHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxHumidity"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"minTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"avgTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"maxTemperature"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"currentWeight"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"weightDelta1d"},"name":{"kind":"Name","value":"deltaWeight"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"past"},"value":{"kind":"StringValue","value":"1d","block":false}}],"directives":[]}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":710}};
    doc.loc.source = {"body":"query sitesDashboard {\n  currentAccount {\n    id\n    sites {\n      id\n      name\n      metricStats {\n        minHumidity\n        avgHumidity\n        maxHumidity\n\n        minTemperature\n        avgTemperature\n        maxTemperature\n\n        currentWeight\n        weightDeltas5d: deltaWeights(past:\"5d\", timeBucket: \"1d\")\n        weightDelta1d: deltaWeight(past:\"1d\")\n        weightDelta1w: deltaWeight(past:\"1w\")\n      }\n\n      hives {\n        id\n        metricStats {\n          minHumidity\n          avgHumidity\n          maxHumidity\n\n          minTemperature\n          avgTemperature\n          maxTemperature\n\n          currentWeight\n          weightDelta1d: deltaWeight(past:\"1d\")\n        }\n      }\n\t\t}\n  }\n}","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["sitesDashboard"] = oneQuery(doc, "sitesDashboard");
        
